import React from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import {
  BaseButton,
  BaseTextField,
  BaseTypography,
} from '../../../../../components/common';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  submitBtn: {
    marginTop: '20px',
  },
  content: {
    display: 'grid',
    gridGap: '15px',
  },
}));

type PMsCodeForm = {
  onUseRecoveryCode?: any;
  onSubmit: any;
  loading?: boolean;
};

export const MsCodeForm: React.FC<PMsCodeForm> = (props) => {
  const { onSubmit, onUseRecoveryCode, loading } = props;
  const classes = useStyles();
  const formik = useFormik({
    validationSchema: yup.object().shape({
      secret: yup.string().test(
        'len',
        'Must be exactly 6 characters',
        // @ts-ignore
        (val) => val && val.length === 6,
      ),
    }),
    initialValues: {
      secret: '',
    },
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (values) => {
      onSubmit(values);
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className={classes.content}>
        <BaseTypography variant="caption">
          Enter the 6-digit verification code generated by your Authenticator
          app <br />
          Or{' '}
          <span className="primary pointer" onClick={onUseRecoveryCode}>
            Use recovery code
          </span>
        </BaseTypography>

        <BaseTextField
          label="Code"
          value={formik.values.secret}
          onChange={formik.handleChange}
          errorText={formik.errors.secret}
          name="secret"
        />
        <BaseButton
          type="submit"
          className={classes.submitBtn}
          fullWidth
          loading={loading}
        >
          Send
        </BaseButton>
      </div>
    </form>
  );
};
